/**
 * Horizontal card slider — prev / next scroll buttons.
 *
 * Looks for `[data-slider-prev]` and `[data-slider-next]` buttons.
 * The attribute value is the `id` of the scrollable track element.
 *
 * Scroll amount is responsive:
 *   ≥ 1024 px  → 340 px
 *   ≥  640 px  → 316 px
 *   <  640 px  → 296 px
 */
export function initSlider() {
  function getScrollAmount() {
    if (window.innerWidth >= 1024) return 340;
    if (window.innerWidth >= 640) return 316;
    return 296;
  }

  document.querySelectorAll('[data-slider-prev],[data-slider-next]').forEach((btn) => {
    const trackId = btn.dataset.sliderPrev || btn.dataset.sliderNext;
    const track = document.getElementById(trackId);
    if (!track) return;

    const direction = btn.dataset.sliderPrev ? -1 : 1;

    btn.addEventListener('click', () => {
      track.scrollBy({ left: direction * getScrollAmount(), behavior: 'smooth' });
    });
  });
}
